import { useQuery } from '@apollo/client'
import {
  GET_USER_CALENDAR_QUERY,
  UserCalendarData
} from 'src/api/onboarding/queries/getUserCalendar'

export const useGetUserCalendar = () => {
  const { data, loading, error } = useQuery<UserCalendarData>(
    GET_USER_CALENDAR_QUERY,
    {
      fetchPolicy: 'cache-first'
    }
  )

  return { data: data?.getUserCalendar, loading, error }
}
